export enum FaqType {
  PANEL = 'panel',
  WRITER = 'writer'
}